export default {"src":"/_next/static/media/help.e091c7ca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};